import type { ElementType } from 'react';

import { type BoxProps, Stack } from '@mui/material';

export const DashboardLayoutContentWrapper = ({
  children,
  ...props
}: BoxProps) => {
  return (
    <Stack
      flexDirection="column"
      alignItems="center"
      {...props}
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: '100%',
        flexGrow: 1,
        px: '4vw',
        overflowY: 'auto',
        ...props.sx,
      }}
      component={'main' as ElementType}
    >
      {children}
    </Stack>
  );
};
